import { guardarBlobComoArchivo } from "./utils";

/**
 * Plantilla DNCTASCSV_V2 con datos ficticios.
 * Importe en centavos; filas M con código operación 300 y TRFDATPROV en info libre.
 */
export const CONTENIDO_CSV_CONCILIACION_EJEMPLO = `I;EJEMPLO;20260616;DNCTASCSV_V2;;;;;;;;;;;;;;;;
Tipo de Registro;Cod. Bco.;Nro Cta. Corto;Fecha Mov.;Deb./Cred.;Saldo;Total Débitos;Total Créditos;Nro. Cta. Largo;Tipo-Moneda DN;;;;;;;;;;
H;285;0;20260616;C;1E+11;19440000;0;3,798E+14;1;;;;;;;;;;
Tipo de Registro;Cod. Bco.;Nro Cta. Corto;Fecha Mov.;Fecha Valor;Deb./Cred.;Importe;Nro. Comprob.;Cod. Operación;Fecha Proceso;;Info. Libre;Suc. Origen;Cod. Depositante;Nro. Cta. Largo;Cod. Ope. Bco.;Tipo-Moneda DN;CBU;CUIT/CUIL;Denominación
M;285;0;20260611;20260611;D;19440000;90000001;300;20260611;;TRFDATPROV- TRANSF DATANE;798;        ;3,798E+14;2027;1;2850798130000000531033;30647082293;Maria Candela Grosso     
M;285;0;20260611;20260611;D;3680000;90000002;300;20260611;;TRFDATPROV- TRANSF DATANE;798;        ;3,798E+14;2027;1;2850798130000000531022;30712345678;Transportes Ficticios SA 
M;285;0;20260612;20260612;D;18230000;90000003;300;20260612;;TRFDATPROV- PAGO PROVEEDOR;798;        ;3,798E+14;2027;1;2850798130000000531033;30555666777;Servicios Demo SRL         
`;

export const descargarEjemploConciliacionCsv = () => {
  const blob = new Blob(["\uFEFF", CONTENIDO_CSV_CONCILIACION_EJEMPLO], {
    type: "text/csv;charset=utf-8",
  });
  guardarBlobComoArchivo(blob, "ordenes_pago_conciliacion_ejemplo.csv");
};
